// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceCard-cls1_anK","cls2":"ReferenceCard-cls2_FWd ReferenceCard-cls1_anK"};